import {
  Skeleton,
  Spinner,
  Select,
  ToggleButton,
  ToggleButtonGroup,
  Icon,
  TextField,
} from '@nike/eds';
import { Suspense, useState } from 'react';
import * as R from 'ramda';
import { useDebounce } from 'use-debounce';
import { RECOMMEND_CONCEPT_TYPES } from '../../constants';
import RecommendConceptsTreeView from 'components/RecommendConcepts/RecommendConceptsTreeView';
import RecommendConceptsSearchByIdView from 'components/RecommendConcepts/RecommendConceptsSearchByIdView';
import RecommendConceptsSearchByTermsView from 'components/RecommendConcepts/RecommendConceptsSearchByTermsView';
import CustomErrorBoundary from 'components/CustomErrorBoundary';

const isValidUUID = (str: string) =>
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(
    str,
  );

const RootListLoader = ({ count }: { count: number }) => {
  return (
    <>
      {R.range(1, count).map((c) => (
        <Skeleton height={60} width={'80%'} key={c} className='tw-m-8' />
      ))}
    </>
  );
};
export default function RecommendConcepts() {
  const [valueSelected, setValueSelected] = useState(
    RECOMMEND_CONCEPT_TYPES[0],
  );
  const [treeView, setTreeView] = useState(false);
  const [searchConcepts, setSearchConcepts] = useState('');
  const [searchConceptsVal] = useDebounce(searchConcepts, 1000);
  const onToggleView = () => {
    setTreeView(!treeView);
    if (!treeView) {
      setSearchConcepts('');
    }
  };
  return (
    <section>
      <div className='tw-flex tw-justify-start tw-items-top'>
        <div className=''>
          <ToggleButtonGroup size='medium' className='tw-mx-4 tw-mt-5'>
            <ToggleButton
              onClick={onToggleView}
              beforeSlot={
                treeView ? (
                  <Icon name='ShopnikeApp' />
                ) : (
                  <Icon name='SortDescending' />
                )
              }
              variant='ghost'
            >
              {treeView ? 'Search' : 'Listing'}
            </ToggleButton>
          </ToggleButtonGroup>
        </div>
        <div className='tw-grow tw-flex tw-justify-center'>
          {treeView && (
            <div className='tw-w-1/3'>
              <Select
                id='recommend-concepts-type-selection'
                options={RECOMMEND_CONCEPT_TYPES.map((type) => ({
                  value: type,
                  label: type,
                }))}
                label=''
                defaultValue={{ value: valueSelected, label: valueSelected }}
                onChange={(selected) =>
                  selected && setValueSelected(selected.value)
                }
              />
            </div>
          )}
          {!treeView && (
            <div className='tw-w-1/3'>
              <TextField
                label=''
                id='search-concepts-by-id'
                noBorder={true}
                value={searchConcepts}
                beforeSlot={<Icon name='Search' />}
                placeholder='Enter Concept ID or search terms'
                onChange={(event) => setSearchConcepts(event.target.value)}
              />
            </div>
          )}
        </div>
      </div>
      <CustomErrorBoundary>
        {treeView ? (
          <Suspense fallback={<RootListLoader count={10} />}>
            <RecommendConceptsTreeView conceptType={valueSelected} />
          </Suspense>
        ) : isValidUUID(searchConceptsVal) ? (
          <Suspense fallback={<Spinner className='tw-ml-12 tw-my-2' />}>
            <RecommendConceptsSearchByIdView conceptId={searchConceptsVal} />
          </Suspense>
        ) : (
          searchConceptsVal.trim() !== '' && (
            <Suspense fallback={<Spinner className='tw-ml-12 tw-my-2' />}>
              <RecommendConceptsSearchByTermsView
                searchTerms={searchConceptsVal}
              />
            </Suspense>
          )
        )}
      </CustomErrorBoundary>
    </section>
  );
}
